// Components/ui
import { styled, Box } from '@mui/material';

export const StyledBoxContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 2,
  alignItems: 'center',
})) as typeof Box;
export const StyledDialogContextText = styled(Box)(({ theme }) => ({
  width: '15%',
  userSelect: 'none',
  color: theme.palette.text.secondary,
})) as typeof Box;
